import { useState, Dispatch } from 'react';

export default (initialToggled: boolean = false) => {
    const [ toggled, setToggle ]: [ boolean, Dispatch<(prev: boolean) => boolean>] = useState(initialToggled);

    const toggle = ():void => setToggle((prev: boolean):boolean => !prev);

    return [ toggled, toggle ]
}